import { LogLevel } from '@azure/msal-browser';

import { clientId, redirectUri } from './utils/Constants';

export const msalConfig = {
  auth: {
    clientId,
    authority: 'https://login.microsoftonline.com/cef04b19-7776-4a94-b89b-375c77a8f936',
    redirectUri,
    // This ensures MSAL navigates back to the URL that initiated the login
    navigateToLoginRequestUrl: true,
    // Use popup instead of redirect for a smoother UX (optional)
    // navigateToLoginRequestUrl applies to redirect flow
  },
  cache: {
    cacheLocation: 'localStorage', // Use localStorage to persist auth across tabs
    storeAuthStateInCookie: false, // Don't need cookies for SPA
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            console.warn(`Unexpected log level: ${level}`);
        }
      },
    },
    // Allow redirects to the same URL
    allowRedirectInIframe: false,
  },
};
